import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    if (!user) { setFavorites([]); return; }
    api.get("/favorites").then((r) => setFavorites(r.data)).catch(() => setFavorites([]));
  }, [user]);

  const isFavorite = (id) => favorites.includes(id);

  const toggleFavorite = async (id) => {
    const was = isFavorite(id);
    setFavorites((f) => (was ? f.filter((x) => x !== id) : [...f, id]));
    try {
      if (was) await api.delete(`/favorites/${id}`);
      else await api.put(`/favorites/${id}`);
      return !was;
    } catch {
      setFavorites((f) => (was ? [...f, id] : f.filter((x) => x !== id)));
      return null;
    }
  };

  return (
    <FavoritesContext.Provider value={{ favorites, isFavorite, toggleFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
